import { motion } from 'framer-motion';
import { Box, SimpleGrid } from '@chakra-ui/react';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1],
    },
  },
};

const MotionBox = motion(Box);
const MotionSimpleGrid = motion(SimpleGrid);

/**
 * Container for staggered animations
 * Wrap your list items with this component
 */
export function StaggerContainer({
  children,
  delay = 0.1,
  staggerDelay = 0.1,
  as = 'div',
  ...props
}) {
  const variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: staggerDelay,
        delayChildren: delay,
      },
    },
  };

  const Component = as === 'grid' ? MotionSimpleGrid : MotionBox;

  return (
    <Component
      variants={variants}
      initial="hidden"
      animate="visible"
      {...props}
    >
      {children}
    </Component>
  );
}

/**
 * Individual item in a staggered animation
 * Must be used inside StaggerContainer
 */
export function StaggerItem({
  children,
  direction = 'up',
  ...props
}) {
  const directions = {
    up: { y: 20 },
    down: { y: -20 },
    left: { x: 20 },
    right: { x: -20 },
  };

  const variants = {
    hidden: {
      opacity: 0,
      ...directions[direction],
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: [0.4, 0, 0.2, 1],
      },
    },
  };

  return (
    <MotionBox variants={variants} {...props}>
      {children}
    </MotionBox>
  );
}
